module.exports = "<div class=\"bioPopUp\">\n    <p>\n      charles-myers-bio works!\n    </p>      \n</div>"